import script from "./AllUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./AllUsers.vue?vue&type=script&setup=true&lang=js"

import "./AllUsers.vue?vue&type=style&index=0&id=1b37bc5e&lang=css"

const __exports__ = script;

export default __exports__